module.exports = __webpack_public_path__ + "img/알케미스트 (2).aa754294.png";